









































































































































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { VIPProjectEditViewMixin } from "@/mixins/VIPProjectMixin";
import ProjectDetailCard from "../component/project/ProjectDetailCard.vue";
import ProjectEdit from "../component/project/ProjectEdit.vue";
import {
	db,
	auth,
	busy,
	toaster,
	DBType,
	IVIPProject,
	VIPProject,
	VIPProjectIp,
	VIPProjectIpRest,
	VIPProjectRest,
	VipProjectStatus,
	getCertificateData,
	getVipCertificateTypeLabel,
	IVIPCertificate,
	VIPCertificate,
	VIPCertificateIpRest,
	VIPCertificateRest,
	VipCertificateStatus,
	VipCertificateType,
	VIPCompanyRest,
	VIPUserRest,
	IVIPProjectRestGetParams,
	createEventInfo,
	DEBUG,
	vip,
} from "@/loader/public";
import dayjs from 'dayjs';

@Component({
	name: "ProjectView",
	components: {
		ProjectDetailCard,
		ProjectEdit,
	}
})
export default class ProjectView extends Mixins(VIPProjectEditViewMixin({
	redirection: { name: "Projects" },
	loadMessage: "Chargement du projet ...",
	getParams: {
		options: {
			ips: true,
			company: { contacts: true },
			manager: true,
			certificates: {
				ips: true,
				events: { event: true }
			},
		}
	},
})) {
	public edit: boolean = false;

	public get canDelete(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.delete_vip_project && (
			auth.user.isManagerOrAbove
		);
	}

	public get canViewCertificate(): boolean {
		return !this.edit && auth.user?.capabilities.read_vip_certificate || false;
	}

	public get canCreateCertificate(): boolean {
		return !this.edit && auth.user?.capabilities.create_vip_certificate || false;
	}

	public get certificates(): VIPCertificate[] {
		return db.certificates.list.filter(c => c.fk_project === this.id);
	}

	public get workCertificate(): VIPCertificate | null {
		return db.certificates.list.find(c => c.fk_project === this.id && c.isTypeWorkCertificate) || null;
	}

	public get abilityCertificate(): VIPCertificate | null {
		return db.certificates.list.find(c => c.fk_project === this.id && c.isTypeAbilityCertificate) || null;
	}

	public get isBid(): boolean {
		return this.item?.isStatusBid || false;
	}

	public get isSigned(): boolean {
		return this.item?.isStatusSigned || false;
	}

	public get isCancelled(): boolean {
		return this.item?.isStatusCancelled || false;
	}

	public get isEnded(): boolean {
		return this.item?.isStatusEnded || false;
	}

	public get isArchived(): boolean {
		return this.item?.isStatusArchived || false;
	}

	public get pips(): VIPProjectIp[] {
		return this.item?.ips.sort((a, b) => (a.ip?.code.toString() || "").localeCompare(b.ip?.code.toString() || "")) || [];
	}

	public editProject() {
		// vip.showProject(this.item);
		this.edit = true;
	}

	public stopEdit() {
		if (this.item && this.item.id.toString() !== this.$route.params.id) {
			this.$router.push({ name: "Project", params: { id: this.item.id.toString() } });
		}
		this.edit = false;
	}

	@Watch("isNew", { immediate: true })
	public checkIsNew(newValue: boolean, oldValue: boolean) {
		if (newValue && newValue !== oldValue) {
			this.editProject();
		} else if (!newValue && newValue !== oldValue) {
			this.stopEdit();
		}
	}

	public sign() {
		if (this.item && this.isBid) {
			this.item.status = VipProjectStatus.signed;
			busy.start(`Acceptation du projet ${this.item.name} ...`);
			VIPProjectRest.update(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Projet accepté", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public refuse() {
		if (this.item && this.isBid) {
			this.item.status = VipProjectStatus.cancelled;
			busy.start(`Annulation du projet ${this.item.name} ...`);
			VIPProjectRest.update(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Projet annulé", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public end() {
		if (this.item && this.isSigned) {
			this.item.status = VipProjectStatus.ended;
			busy.start(`Fin du projet ${this.item.name} ...`);
			VIPProjectRest.update(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Projet terminé", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public archive() {
		if (this.item && this.isEnded) {
			this.item.status = VipProjectStatus.archived;
			busy.start(`Archivage du projet ${this.item.name} ...`);
			VIPProjectRest.update(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Projet terminé", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public unarchive() {
		if (this.item && this.isArchived) {
			this.item.status = VipProjectStatus.ended;
			busy.start(`Désarchivage du projet ${this.item.name} ...`);
			VIPProjectRest.update(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Projet désarchivé", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public createAbilityCertificate() {
		this.createCertificate(VipCertificateType.abilityCertificate);
	}

	public createWorkCertificate() {
		this.createCertificate(VipCertificateType.workCertificate);
	}

	public createCertificate(type: VipCertificateType) {
		if (this.item && this.isEnded) {
			busy.start(getVipCertificateTypeLabel(type) + " : création en cours ...");

			let id: number = 0;
			let data: IVIPCertificate = getCertificateData(type, this.item);

			// @ts-ignore
			VIPCertificateRest.create(data).then(result => {
				if (result.success && this.item) {
					id = result.item?.id || 0;
					if (id) {
						return VIPCertificateIpRest.batch(id, this.item.ips.map(pip => pip.fk_ip));
					}
				}
				return result;
			}).then(result => {
				if (id) {
					this.$router.push({ name: "Certificate", params: { id: id.toString() } });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public viewCertificate(certificate: VIPCertificate) {
		this.$router.push({ name: "Certificate", params: { id: certificate.id.toString() } });
	}

	public loadDependencies() {
		if (this.item) {
			VIPCertificateRest.list({ fk_project: this.id, options: { ips: true, events: { event: true } } });
			if (!this.item.ips.length) {
				VIPProjectIpRest.list(this.id);
			}
			if (!this.item.company) {
				VIPCompanyRest.get({ id: this.item.fk_company }, { options: { contacts: true } });
			}
			if (!this.item.manager && this.item.fk_manager) {
				VIPUserRest.get({ id: this.item.fk_manager });
			}
		}
	}

	public clone() {
		if (!this.item || this.isNew) {
			return;
		}

		busy.start("Copie en cours ...");
		let ips = this.item.ips.map(pip => pip.fk_ip);
		let project = db.projects.insert({
			id: db.projects.list.nextNewId(),
			fk_company: this.item.fk_company,
			fk_manager: this.item.fk_manager,
			fk_contact: this.item.fk_contact,
			status: VipProjectStatus.bid,
			name: this.item.name + " - Copie",
			description: this.item.description,
		});

		VIPProjectRest.create(project).then(result => {
			if (result.success && result.item) {
				return VIPProjectIpRest.batch(result.item.id, ips);
			}
		}).then(result => {
			if (result && result.success) {
				this.$router.push({ name: "Project", params: { id: project.id.toString() } });
			}
		}).finally(() => {
			busy.stop();
		});
	}
}
